<style lang="scss">
.menu-title {
	cursor: pointer;
	user-select: none;
	padding: 2px 12px 2px 6px;
	float: unset !important;
	&:hover {
		background-color: #d5e8fc;
	}
}

.menu-node-btn {
	display: inline-block;
	float: right;
	button {
		margin-right: 8px;
		padding: 5px 7px;
	}
	.vview-button-icon {
		margin: 0;
	}
}

.menu-title-active {
	background-color: #d5e8fc;
}
.menu-search {
	margin: 10px 20px;
}
</style>

<template>
	<div>
		<vInput
			class="menu-search"
			v-model="search"
			@on-enter="handleInput"
			suffix="search"
			@on-icon-click="handleInput"
			placeholder="支持id,labelId,labelKey,title,url等搜索"
		></vInput>
		<vTree style="min-height:70vh;" :data="getNodes" :render="renderNode" ref="tree"></vTree>
		<vLoading size="large" transfer loading v-if="isLoading"></vLoading>
		<vTooltip
			:reference="reference"
			always
			placement="right-center"
			:offset="15"
			v-if="reference&&popperTip"
		>
			<div slot="content" style="padding-top:3px">{{popperTip}}</div>
		</vTooltip>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	data() {
		return {
			search: "",
			operateId: null,
			linkIndex: "",
			reference: null,
			popperTip: null
		};
	},
	computed: {
		...mapGetters('ucadm', ['getAuthmenu']),
		isLoading() {
			return !this.getAuthmenu.length
		},
		getNodes() {
			const data = JSON.parse(JSON.stringify(this.getAuthmenu))
			const Nodes = [];
			data.forEach(item => {
				const parentId = item.parentId;
				if (!parentId) return Nodes.push(item);
				const parent = data.find(function (item) {
					return parentId === item.id;
				});
				if (!parent) return;
				const children = parent.children;
				if (children) {
					children.push(item);
				} else {
					parent.children = [item];
				}
			});
			Nodes.forEach((item) => {
				item.expand = true;
			})
			return Nodes;
		},
	},

	methods: {
		handleInput(val) {
			let indistinctTarget,
				target = this.getAuthmenu.find(function (item) {
					if (!indistinctTarget && val && `${item.title}`.indexOf(val) > -1) indistinctTarget = item;
					return val && (val == item.labelId || val == item.title || val == item.id || val == item.url || val == item.langKey);
				}) || indistinctTarget;
			if (target) {
				this.$refs.tree.initStatus(['id', this.operateId = target.id]);
				this.$emit('on-data', target, 'edit');
				setTimeout(() => {
					const ele = document.querySelector(`.vview-treenode-li[data-id="${this.operateId}"]`);
					ele.scrollIntoView({ block: "center" });
				}, 600)
			}
		},
		renderNode(h, {
			node,
			data,
			ctx,
		}) {
			let active = this.operateId === data.id;
			return <div
				class={{ "menu-title": true, 'menu-title-active': active }}
				onDragstart={this.handleDragStart.bind(this, node, data)}
				onDragover={this.handleDragover}
				onDragenter={this.handleDragenter.bind(this, node, data)}
				onDragend={this.handleDragend}
				onDrop={this.handleDrop.bind(this, node, data)}
			>
				<span data-type="inner" draggable>{data.title}</span>
				<aside class="menu-node-btn">
					<vButton
						title="添加子节点"
						icon='add'
						theme='primary'
						size='small'
						onClick={this.appendNode.bind(this, node, data)}
					></vButton>
					{data.parentId ? [<vButton
						title="编辑该节点"
						icon='create'
						size='small'
						theme='info'
						onClick={this.getNode.bind(this, node, data)}
					></vButton>,
					<vButton
						title="删除该节点"
						icon='remove'
						size='small'
						onClick={this.removeNode.bind(this, node, data)}
					></vButton>] : null}
				</aside>
			</div>
		},
		handleKeepStatus() {
			if (linkIndex) {
				this.$refs.tree.status = linkIndex.split(',')
			}
		},
		handleDragStart(node, data, event) {
			event.stopPropagation();
			this._dragData = data;
		},
		handleDragover(event) {
			event.stopPropagation();
			event.preventDefault();
			if (this._targetEle) this._targetEle.style.backgroundColor = "";
			this._targetEle = event.currentTarget;
			this._targetEle.style.backgroundColor = "#d5e8fc"
		},
		handleDragenter(node, data, event) {
			event.stopPropagation();
			const result = this.handleMoveType(node, data, event);
			if (result) {
				this.popperTip = result.tip;
				this.reference = event.currentTarget.querySelector('span[data-type]');
			} else {
				this.popperTip = this.reference = null;
			}
		},
		handleDragend() {
			this.reference = false;
			this._targetEle.style.backgroundColor = "";
		},
		handleMoveType(parentNode, dropData, event) {
			const dropLinkIndex = dropData._linkIndex || "",
				dragData = this._dragData,
				dragLinkIndex = dragData._linkIndex;
			if (dropLinkIndex.indexOf(dragLinkIndex) != 0 && dragData) {
				let target = event.target, moveType = 2, tip = "作为子节点插入";
				if (target.dataset.type === 'inner') {
					moveType = 1;
				} else if (parentNode) {
					let pos = event.currentTarget.offsetHeight / 2;
					if (pos < event.offsetY) {
						let index = parseInt(dropLinkIndex.split(',').pop()) + 1
						let targetNode = parentNode.children[index];
						if (targetNode) {
							dropData = targetNode
						} else {
							moveType = 1;
							dropData = parentNode
						}
						tip = "作为后一节点插入"
					} else {
						tip = "作为前一节点插入"
					}
				}
				return {
					dropId: dropData.id,
					// droptitle: dropData.title,
					// dragtitle: dragData.title,
					dragId: dragData.id,
					moveType,
					tip,
				}
			}
		},
		handleDrop(parentNode, dropData, event) {
			event.stopPropagation();
			const result = this.handleMoveType(parentNode, dropData, event);
			this.handleDragend();
			if (result) {
				console.log(result)
				this.$emit('on-data', {
					srcId: result.dragId,
					targetId: result.dropId,
					moveType: result.moveType,
				}, 'move');
			}

		},
		getNode(node, data, event) {
			event.stopPropagation();
			this.operateId = data.id;
			this.$emit('on-data', data, 'edit');
		},
		removeNode(node, data, event) {
			event.stopPropagation();
			this.operateId = data.id;
			this.$emit('on-data', {
				id: data.id,
				parentId: data.parentId,
				title: data.title
			}, 'delete');
		},
		appendNode(node, data, event) {
			event.stopPropagation();
			this.operateId = data.id;
			this.$emit('on-data', {
				parentId: data.id
			}, 'add');
		},
	},
};
</script>
